module.exports = __webpack_public_path__ + "static/media/sidebar-1.b412a34e.jpg";